<template>
    <div :class="userTopBlockClasses">
        <div class="left-side  w-100">
            <div class="left-side-info">
                <div class="person-info-wrap sites-info-wrap">
                    <div class="person-info">
                        <div class="name">{{ user.name }} {{ user.last_name }}</div>
                        <div class="position">{{user.job_title}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'UserInfoBlock',
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    computed: {
        userTopBlockClasses() {
            const statusClasses = {
                'active': 'active',
                'inactive': 'inactive'
            };

            return ['applicant-full-top-block', `applicant-full-top-block-${statusClasses[this.user.status]}`];
        },
    },
}

</script>


<style scoped>

</style>
